"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZListBox = void 0;
require("react-dual-listbox/lib/react-dual-listbox.css");
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_dual_listbox_1 = __importDefault(require("react-dual-listbox"));
const lodash_1 = __importDefault(require("lodash"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.ZListBox = (props) => {
    const { defaultValue, value, options, onChange, width, height, lang, disabled } = props;
    const [selected, setSelected] = React.useState(value || defaultValue || []);
    const StyledWrapper = styled_components_1.default.div `
      & .rdl-filter,
      .rdl-control {
         border-radius: 3px 3px;
      }
      & .rdl-move {
         border-radius: 3px 3px;
         &:hover:not(:disabled) {
            background-color: ${props => props.theme["hover-color"]} !important;
            color: ${props => props.theme["action-button-hover-text-color"]} !important;
         }
         &:active:not(:disabled) {
            background-color: ${props => props.theme["active-color"]} !important;
            color: ${props => props.theme["action-button-hover-text-color"]} !important;
         }
      }
      option {
         padding-top: 3px;
         padding-bottom: 3px;

         :not(:disabled)&:hover {
            background-color: #ebebeb;
         }
      }
      .react-dual-listbox {
         ${height
        ? `height: ${typeof height === "number" ? `${height}px` : height};`
        : ""}
      }
      width: ${typeof width === "number" ? `${width}px` : width};
   `;
    return (React.createElement(StyledWrapper, null,
        React.createElement(react_dual_listbox_1.default, { selected: value || selected, onChange: (newSelected) => {
                let previousSelected = selected;
                let changeEvent = {
                    selected: [],
                    deselected: [],
                    newState: newSelected
                };
                changeEvent.selected = lodash_1.default.difference(newSelected, previousSelected);
                changeEvent.deselected = lodash_1.default.difference(previousSelected, newSelected);
                setSelected(newSelected);
                onChange(changeEvent);
            }, options: options, icons: {
                moveLeft: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "chevron-left" }),
                moveAllLeft: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "chevron-double-left" }),
                moveRight: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "chevron-right" }),
                moveAllRight: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "chevron-double-right" })
            }, showHeaderLabels: lang && !!(lang.availableHeader && lang.selectedHeader), lang: lang, disabled: disabled })));
};
//# sourceMappingURL=ZListBox.js.map